import { Record, List } from 'immutable';

export const defaultApiValues = {
  adId: null,
  name: null,
  email: null,
  opcoId: null,
};

// object dto with api
const SalesConsultantDto = Record({ ...defaultApiValues });

/**
 * 
 * @param {Array} rawObjects array of sales consultant objects
 * @returns 
 */
export const mapToRecords = rawObjects => {
  let salesConsultants = new List();
  if (!rawObjects) {
    return salesConsultants;
  }

  for (const record of rawObjects) {
    salesConsultants = salesConsultants.push(new SalesConsultantDto(record));
  }

  return salesConsultants;
};

export default SalesConsultantDto;
